import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container pt-5 mt-5 text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "display-1 pb-3" }, "404", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Siden finnes ikke.", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Tilbake til resultatlistene")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" her")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("! ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("p", null, [
      _hoisted_4,
      _createVNode(_component_router_link, {
        class: "fw-bold",
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _hoisted_6
    ])
  ]))
}